import { AuthProviderConfig } from './authManager';

export const AUTH_CONFIG: AuthProviderConfig = {
  google: {
    appId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
    scope: ['email', 'profile']
  },
  facebook: {
    appId: process.env.REACT_APP_FACEBOOK_APP_ID || '',
    scope: ['public_profile']
  },
  instagram: {
    appId: process.env.REACT_APP_INSTAGRAM_CLIENT_ID || '',
    scope: ['basic', 'public_content']
  },
  emailPassword: {
    enabled: true // Always enabled for email/password auth
  }
};

// Check if providers are enabled based on environment variables
export const isProviderEnabled = (provider: string): boolean => {
  switch (provider) {
    case 'google':
      return !!process.env.REACT_APP_GOOGLE_ENABLED || !!process.env.REACT_APP_GOOGLE_CLIENT_ID;
    case 'facebook':
      return !!process.env.REACT_APP_FACEBOOK_ENABLED || !!process.env.REACT_APP_FACEBOOK_APP_ID;
    case 'instagram':
      return !!process.env.REACT_APP_INSTAGRAM_ENABLED || !!process.env.REACT_APP_INSTAGRAM_CLIENT_ID;
    case 'emailPassword':
      return true; // Always enabled
    default:
      return false;
  }
};

// Get enabled providers
export const getEnabledProviders = (): string[] => {
  return ['google', 'facebook', 'emailPassword'].filter(isProviderEnabled);
};

// Validate configuration
export const validateAuthConfig = (): { valid: boolean; errors: string[] } => {
  const errors: string[] = [];
  
  if (!process.env.REACT_APP_GOOGLE_CLIENT_ID && !process.env.REACT_APP_GOOGLE_ENABLED) {
    errors.push('Google authentication is not configured. Set REACT_APP_GOOGLE_CLIENT_ID or REACT_APP_GOOGLE_ENABLED=true');
  }
  
  if (!process.env.REACT_APP_FACEBOOK_APP_ID && !process.env.REACT_APP_FACEBOOK_ENABLED) {
    errors.push('Facebook authentication is not configured. Set REACT_APP_FACEBOOK_APP_ID or REACT_APP_FACEBOOK_ENABLED=true');
  }
  
  if (!process.env.REACT_APP_INSTAGRAM_CLIENT_ID && !process.env.REACT_APP_INSTAGRAM_ENABLED) {
    errors.push('Instagram authentication is not configured. Set REACT_APP_INSTAGRAM_CLIENT_ID or REACT_APP_INSTAGRAM_ENABLED=true');
  }
  
  return {
    valid: errors.length === 0,
    errors
  };
}; 